// extracted by mini-css-extract-plugin
export default {"techteamlink":"Acko_techteamlink__XSySG","techanchor":"Acko_techanchor__6sc1u"};